
export const FONT_SIZE_SCALE_FACTOR = 15;
export const MIN_FONT_SIZE = 14;
export const MAX_FONT_SIZE = 72;
export const DEFAULT_FONT_SIZE = 18;

export interface LineBounds {
    width: number;
    height: number;
}

export function lineBoundsBox(lineBounds: LineBounds[]): LineBounds {
    return {
        width: Math.max(...lineBounds.map(row => row.width)),
        height: lineBounds.reduce((sum, row) => sum + row.height, 0),
    };
}

export interface SubtitleStyle {
    fontSize?: number;  // px at original resolution
    fontFamily?: string;
    fontWeight?: 'normal' | 'bold';
    fontStyle?: 'normal' | 'italic';
    color?: string;
    backgroundColor?: string;
    borderRadius?: number; // px at original resolution
    centerX?: number; // percentage (0-100)
    centerY?: number; // percentage (0-100)
    paddingX?: number; // px at original resolution
    paddingY?: number; // px at original resolution
    shadowDistance?: number;
    shadowColor?: string;
    backgroundMode?: 'unified' | 'per-line';
    lineBounds?: LineBounds[]; // px at original resolution, minimum background row per line in per-line mode
}

export const defaultSubtitleStyle: SubtitleStyle = {
    fontSize: DEFAULT_FONT_SIZE,
    fontFamily: 'Arial',
    color: 'rgba(255, 255, 255, 1)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    fontWeight: 'normal',
    fontStyle: 'normal',
    centerX: 50,
    centerY: 85,
    paddingX: 1,
    paddingY: 1,
    backgroundMode: 'per-line'
};

export function calculateProportionalFontSize(videoHeight: number): number {
    if (videoHeight <= 0) {
        return DEFAULT_FONT_SIZE;
    }

    return Math.max(
        MIN_FONT_SIZE,
        Math.min(MAX_FONT_SIZE, Math.round(videoHeight / FONT_SIZE_SCALE_FACTOR))
    );
}
